/**
 * A leading tag on a provider's title or channel name: "[NL] ", "(US) ", "|EN| ",
 * "NL - ", "NL: ", "UK| ". Providers put the country or language first, so the
 * first character was often a bracket.
 */
const LEADING_TAG = /^\s*(?:[[(|][^\])|]{1,12}[\])|]|[A-Z]{2,3}\s*[-–:|])\s*/;
const LETTER = /[\p{L}\p{N}]/u;

/**
 * The letter a tile shows when there is no artwork: the first letter or digit
 * after any leading country tag, so "[NL] Elected" shows "E", not "[" (owner,
 * 2026-10-08). A name that is nothing but a tag keeps its own first letter.
 */
export function tileLetter(name: string | null | undefined, fallback: string): string {
  const full = name ?? "";
  let rest = full;
  for (let i = 0; i < 3; i++) {
    const next = rest.replace(LEADING_TAG, "");
    if (next === rest) break;
    rest = next;
  }
  const letter = rest.match(LETTER)?.[0] ?? full.match(LETTER)?.[0];
  return letter ? letter.toUpperCase() : fallback;
}
